export class IndexedDB {

    constructor ({ vistra, nomeBanco, versao, tabelaPadrao, tabelas, onsuccess, onerror }) {
        //tabelas: [{ nome, campos: [{ nome, unico }] }]
        this.$vistra = vistra
        this.nomeBanco = nomeBanco
        this.database = null
        this.tabelaPadrao = tabelaPadrao
        let indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB

        const DBOpenRequest = indexedDB.open(nomeBanco, versao);
        
        DBOpenRequest.onerror = event => {
            console.error(`IndexedDB: Erro ao carregar database ${nomeBanco} versão ${versao}`);
            if (onerror)
                onerror(event)
        };

        DBOpenRequest.onsuccess = event => {
            this.database = event.target.result;
            if (onsuccess)
                onsuccess(this.database);
        };

        DBOpenRequest.onupgradeneeded = event => {
            this.database = event.target.result;
            const storeNames = this.database.objectStoreNames;
            let objectStore = null;

            for (let tabela of tabelas) {
                if (storeNames.contains(tabela.nome)) {
                    this.database.deleteObjectStore(tabela.nome)
                }
                
                objectStore = this.database.createObjectStore(tabela.nome, { keyPath: tabela.chave || "id" });
                tabela.campos.forEach(campo => {
                    objectStore.createIndex(campo.nome, campo.nome, { unique: campo.unico || false });    
                });
                
                this.database.onerror = (event) => {
                    console.error("IndexedDB: Erro ao carregar tabela "+ tabela.nome)
                };
            }
        };
    }

    openDbTransaction(tabela, tipo) {
        let transaction = this.database.transaction(tabela, tipo || "readwrite")

        transaction.oncomplete = event => {
            //console.show('IndexedDB: transaction completed')
        }

        transaction.onerror = event => {
            console.log('IndexedDB: transaction error found', JSON.stringify(event))
        }

        return transaction.objectStore(tabela)
    }

    getAll(tabela) {
        return new Promise((resolve, reject) => {
            this.$vistra.Objetos.when(
                () => this.database,
                () => {
                    const objectStore = this.openDbTransaction(tabela || this.tabelaPadrao, "readonly")
                    if ('getAll' in objectStore) { //se suporta getAll
                        const request = objectStore.getAll(tabela)
                        request.onsuccess = event => {
                            resolve(event.target.result)
                        }
                        request.onerror = event => {
                            reject([])
                        }
                    }
                    else {
                        let registros = []
                        const request = objectStore.openCursor(tabela || this.tabelaPadrao)
                        request.onsuccess = event => {
                            const cursor = event.target.result;
                            if (cursor) {
                                registros.push(JSON.parse(cursor.value))
                                cursor.continue();
                            } else {
                                resolve(registros)
                            }
                        }
                        request.onerror = event => {
                            reject([])
                        }
                    }
                }
            )
        })
    }

    get(id, tabela) {
        return new Promise((resolve, reject) => {
            this.$vistra.Objetos.when(
                () => this.database,
                () => {
                    const objectStore = this.openDbTransaction(tabela || this.tabelaPadrao, "readonly")
                    const request = objectStore.get(id)
                    request.onsuccess = event => {
                        resolve(event.target.result)
                    }
                    request.onerror = event => {
                        reject([])
                    }
                }
            )
        })
    }

    clear(tabela) {
        const objectStore = this.openDbTransaction(tabela || this.tabelaPadrao)
        return objectStore.clear()
    }

    add(registro, tabela) {
        const objectStore = this.openDbTransaction(tabela || this.tabelaPadrao)
        window.trace
        return objectStore.add(registro)
    }

    delete(id, tabela) {
        const objectStore = this.openDbTransaction(tabela || this.tabelaPadrao)
        return objectStore.delete(id)
    }

    async put(registro, tabela) {
        const objectStore = this.openDbTransaction(tabela || this.tabelaPadrao)
        return objectStore.put(registro)
    }

    openCursor(sucesso, tabela) {
        const objectStore = this.openDbTransaction(tabela || this.tabelaPadrao, "readonly")
        objectStore.openCursor().onsuccess = sucesso
    }

}